import React, { useEffect } from 'react';
import { ArrowLeft } from 'lucide-react';
import { useNavigate, Link } from 'react-router-dom';

const MentionsLegalesPage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const goBack = () => {
    // Retourner à l'accueil
    navigate('/');
  };

  return (
    <div className="mentions-legales-page">
      <div className="mentions-container">
        <button className="back-btn" onClick={goBack}>
          <ArrowLeft size={20} />
          Retour à l'accueil
        </button>

        <h1>Mentions Légales</h1>
        <p className="last-update">Dernière mise à jour : Janvier 2025</p>

        <section>
          <h2>1. Éditeur du site</h2>
          <p>Le site MonCoach.eu est édité par :</p>
          <div className="info-block">
            <p><strong>NOTHING</strong></p>
            <p>SASU au capital de 1 000,00 €</p>
            <p>SIREN : 892 798 208</p>
            <p>SIRET : 892 798 208 00021</p>
            <p>RCS Paris</p>
            <p>N° TVA Intracommunautaire : FR81892798208</p>
            <p><strong>Siège social :</strong> 58 rue de Monceau, 75008 Paris, France</p>
          </div>
        </section>

        <section>
          <h2>2. Directeur de la publication</h2>
          <div className="info-block">
            <p><strong>Enzo Martin</strong></p>
            <p>En qualité de directeur de la publication</p>
          </div>
        </section>

        <section>
          <h2>3. Hébergeur</h2>
          <div className="info-block">
            <p><strong>OVH SAS</strong></p>
            <p>2 rue Kellermann, 59100 Roubaix, France</p>
            <p>Téléphone : 1007</p>
            <p>Site web : www.ovh.com</p>
          </div>
        </section>

        <section>
          <h2>4. Propriété intellectuelle</h2>
          <p>
            L'ensemble du contenu de ce site (textes, images, vidéos, logos, icônes, sons, logiciels, etc.) 
            est la propriété exclusive de NOTHING ou de ses partenaires et est protégé par les lois françaises 
            et internationales relatives à la propriété intellectuelle.
          </p>
          <p>
            Toute reproduction, représentation, modification, publication, adaptation de tout ou partie des 
            éléments du site, quel que soit le moyen ou le procédé utilisé, est interdite, sauf autorisation 
            écrite préalable de NOTHING.
          </p>
        </section>

        <section>
          <h2>5. Données personnelles</h2>
          <p>
            Conformément au Règlement Général sur la Protection des Données (RGPD) et à la loi Informatique 
            et Libertés, vous disposez d'un droit d'accès, de rectification, de suppression et d'opposition 
            aux données personnelles vous concernant.
          </p>
          <p>
            Pour exercer ces droits ou pour toute question relative à vos données personnelles, vous pouvez 
            nous contacter à l'adresse : contact@moncoach.eu
          </p>
          <p>
            Les données collectées sont utilisées uniquement dans le cadre de l'utilisation du service 
            MonCoach et ne sont jamais revendues à des tiers.
          </p>
        </section>

        <section>
          <h2>6. Cookies</h2>
          <p>
            Le site MonCoach.eu utilise des cookies pour améliorer l'expérience utilisateur et analyser 
            le trafic. En continuant à naviguer sur ce site, vous acceptez l'utilisation des cookies.
          </p>
        </section>

        <section>
          <h2>7. Limitation de responsabilité</h2>
          <p>
            Les informations et conseils fournis par MonCoach sont donnés à titre informatif et ne 
            constituent en aucun cas un avis médical. Il est recommandé de consulter un professionnel 
            de santé avant d'entreprendre tout régime alimentaire ou programme de perte de poids.
          </p>
          <p>
            NOTHING ne saurait être tenue responsable des dommages directs ou indirects résultant de 
            l'utilisation du site ou de l'impossibilité d'y accéder.
          </p>
        </section>

        <section>
          <h2>8. Contact</h2>
          <p>
            Pour toute question concernant ces mentions légales ou le site MonCoach, vous pouvez nous 
            contacter par email à : contact@moncoach.eu
          </p>
        </section>

        <section>
          <h2>9. Droit applicable</h2>
          <p>
            Les présentes mentions légales sont soumises au droit français. En cas de litige, les 
            tribunaux français seront seuls compétents.
          </p>
        </section>

        <div className="legal-nav">
          <p>Autres pages légales :</p>
          <div className="legal-links">
            <Link to="/confidentialite">Politique de confidentialité</Link>
            <Link to="/cgv">CGV / CGU</Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MentionsLegalesPage;
